// pages/Recovery.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import TitleSetter from '../components/TitleSetter';
import '../styles/Login.css';

const Recovery = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');
  const [statusType, setStatusType] = useState('');
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();
    setStatus('');
    setStatusType('');
    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email);
      setStatus('success');
      setStatusType('success');
    } catch (err) {
      console.error('Reset failed:', err);
      setStatus('Unable to send a reset link. Please check your email and try again.');
      setStatusType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <TitleSetter title="Password Recovery" />
      <div className="login-container">
        <header className="login-topbar">
          <button className="login-brand" onClick={() => navigate('/landing')} aria-label="Back to TheBox">
            <img src="/assets/theboxlogo.png" alt="TheBox" />
          </button>
          <button className="back-site-btn" onClick={() => navigate('/landing')}>
            Back to site <span aria-hidden="true">&rarr;</span>
          </button>
        </header>

        <div className="login-wrapper">
          <div className="logo-side">
            <div className="login-brand-copy">
              <p className="login-eyebrow">Private team workspace</p>
              <h1>Built for contenders.</h1>
              <p>
                Your competitive workspace for cleaner prep, faster reviews, and better calls.
              </p>
              <h2>Plan. Brief. Scrim. Review. Adapt.</h2>
              <div className="login-proof-points">
                <span>Visual Playbooks</span>
                <span>Stats & Scouting</span>
                <span>Team Calendar</span>
              </div>
            </div>

            <div className="login-trust-note">
              <strong>Private team workspace.</strong>
              <span>Your playbooks, scouting, and stats stay within your team's workspace.</span>
            </div>
          </div>

          <div className="login-card">
            {statusType === 'success' ? (
              <>
                <div className="login-card-header">
                  <p className="login-eyebrow">Password recovery</p>
                  <h1>Check your email.</h1>
                  <p>We sent a password reset link to:</p>
                </div>

                <p className="auth-success-email">{email}</p>

                <button
                  type="button"
                  className="login-submit-btn"
                  onClick={() => navigate('/login')}
                >
                  Back to Sign In <span aria-hidden="true">&rarr;</span>
                </button>
              </>
            ) : (
              <>
                <div className="login-card-header">
                  <p className="login-eyebrow">Password recovery</p>
                  <h1>Recover password</h1>
                  <p>Enter your email and we'll send you a password reset link.</p>
                </div>

                <form onSubmit={handleReset} className="login-form">
                  <label className="field-label" htmlFor="recovery-email">Email</label>
                  <input
                    id="recovery-email"
                    type="email"
                    placeholder="you@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />

                  {statusType === 'error' && (
                    <p className="auth-status auth-status-error" aria-live="polite">
                      {status}
                    </p>
                  )}

                  <button type="submit" className="login-submit-btn" disabled={loading}>
                    {loading ? 'Sending...' : <>Send Reset Link <span aria-hidden="true">&rarr;</span></>}
                  </button>
                </form>

                <p className="register-text">
                  Remembered your password?{' '}
                  <button
                    type="button"
                    onClick={() => navigate('/login')}
                    className="register-link"
                  >
                    Sign in <span aria-hidden="true">&rarr;</span>
                  </button>
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Recovery;
